<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Assessment Type Configuration
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined persistent-hint
                        hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-btn class="mt-6 button" @click="onload()">Fetch / Generate</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="std_assessment_config_list != ''">
            <v-row dense>
                <v-col cols="12" sm="5" md="5" style="text-align: right;">
                    <v-autocomplete rounded dense required v-model="from_std" :items="std_copy_list" item-value="sid"
                        item-text="standard" label="From Standard" outlined />
                </v-col>
                <v-col cols="12" sm="2" md="2" style="text-align: center;">
                    <v-btn text color="#0f2027" :loading="copy_btn_load">
                        <v-icon large color="#0f2027">mdi-arrow-right-bold-circle</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="5" md="5" style="text-align: left;">
                    <v-autocomplete rounded dense required v-model="to_std" multiple :items="std_copy_list"
                        item-value="sid" item-text="standard" label="To Standard" outlined />
                </v-col>
            </v-row>
            <v-row dense justify="center">
                <v-btn :loading="copy_offer_btn_load" @click="copyAssessmentConfig()" class="button">Copy</v-btn>
            </v-row>
            <v-col cols="12" sm="12" md="12">
                <v-simple-table dense class="elevation-1" fixed-header height="500px">
                    <thead>
                        <tr>
                            <th class="">Sr. No.</th>
                            <th class="">Standard</th>
                            <th class="" v-for="(header, index) in assessment_list" :key="index">
                                <center>{{ header }}</center>
                            </th>
                            <th>Save / Update</th>
                        </tr>
                    </thead>
                    <tbody style="overflow-y: scroll;">
                        <tr v-for="(s, index) in std_assessment_config_list" :key="s.sid">
                            <td>{{ index + 1 }}</td>
                            <td>{{ s.standard }}</td>
                            <td v-for="(header, index) in s.assessment_config_list" :key="index">
                                <v-row dense justify="center" v-if="header.assessment_name != 'Annual'">
                                    <v-col cols="12" md="12" sm="12">
                                        <v-icon color="error">*</v-icon>
                                        Start Date :: <input id="datePickerId" type="date"
                                            v-model="header.assessment_start_date" />
                                    </v-col>
                                    <v-col cols="12" md="12" sm="12">
                                        <v-icon color="error">*</v-icon>
                                        End Date :: <input id="datePickerId" type="date"
                                            v-model="header.assessment_end_date" />
                                    </v-col>
                                </v-row>
                                <v-row dense justify="center" v-else>
                                    <v-col cols="12" md="12" sm="12">
                                        <v-icon color="error">*</v-icon>
                                        Start Date :: <input readonly id="datePickerId" type="date"
                                            v-model="header.assessment_start_date" />
                                    </v-col>
                                    <v-col cols="12" md="12" sm="12">
                                        <v-icon color="error">*</v-icon>
                                        End Date :: <input readonly id="datePickerId" type="date"
                                            v-model="header.assessment_end_date" />
                                    </v-col>
                                </v-row>
                            </td>
                            <td>
                                <v-btn small class="button"
                                    @click="saveSingleAssessmentConfig(s.sid, s.assessment_config_list)">Save /
                                    Update</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <center><v-btn :loading="loader" small @click="saveAllAssessmentConfig()" class="button">Save /
                        Update</v-btn></center>
            </v-col>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed


export default {
    components: {
        Breadcrumbs,
    },

    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style2",
    data() {
        return {
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            search: null,
            ay_std_div_list: null,
            sel_ay_data: null,
            ay_id: null,
            std_assessment_config_list: [],
            assessment_list: [],
            loader: false,
            std_copy_list: [],
            from_std: null,
            to_std: [],
            copy_offer_btn_load: false,
        };
    },
    methods: {
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        copyAssessmentConfig() {
            for (var i = 0; i < this.to_std.length; i++) {
                if (this.from_std == this.to_std[i]) {
                    this.showSnackbar("#b71c1c", "From and To Standard cannot be same!!!...");
                    return;
                }
            }
            this.copy_offer_btn_load = true;
            const data = {
                ay: this.sel_ay_data.ay_id,
                from_std: this.from_std,
                to_std: this.to_std,
            };
            axios
                .post("/Academics/copyAssessmentConfig", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", " Copied Successfully..."); // show snackbar on success
                        this.onload();
                        this.copy_offer_btn_load = false;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg);
                        this.copy_offer_btn_load = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.copy_offer_btn_load = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.copy_offer_btn_load = false;
                })
                .finally(() => {
                    this.copy_offer_btn_load = false;
                    (this.from_std = null), (this.to_std = []);
                });
        },
        saveAllAssessmentConfig() {
            this.loader = true;
            const data = {
                ay: this.sel_ay_data.ay_id,
                assessment_config: this.std_assessment_config_list,
            };
            axios
                .post("/Academics/saveAllAssessmentConfig", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", " Save Successfully..."); // show snackbar on success
                        this.onload();
                        this.loader = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.loader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.loader = false;
                })
                .finally(() => {
                    this.loader = false;
                });
        },
        saveSingleAssessmentConfig(sid, header) {
            const data = {
                ay: this.sel_ay_data.ay_id,
                sid: sid,
                assessment_config: header,
            };
            axios
                .post("/Academics/saveSingleAssessmentConfig", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", " Save Successfully..."); // show snackbar on success
                        this.onload();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
        onload() {
            const data = {
                ay: this.sel_ay_data.ay_id,
            };
            this.overlay = true;
            axios
                .post("/Academics/getAssessmentConfig", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.std_copy_list = res.data.std_copy_list;
                        this.std_assessment_config_list = res.data.std_assessment_config_list;
                        this.assessment_list = res.data.assessment_list;
                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        main() {
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                   // this.sel_ay_data = res.data.curr_ay;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.main();
    },
};
</script>
<style scoped>
input[type="date"] {
    width: 85%;
    display: inline-block;
    padding: 0.3rem;
    border: 1px solid gray;
    border-radius: 30px;
    box-sizing: border-box;
    padding-top: none !important;
    margin-top: none !important;
}

.text-color {
    font-weight: bold;
    color: red;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
    }

    td+td,
    th+th {
        width: auto;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}</style>
